<template>
    <div>
        <h1>Sample Size</h1>
        <!-- <i>Estimated number of participants needed to achieve study objectives and how it was determined, including clinical and statistical assumptions supporting any sample size calculations</i> -->
        <i><p>Some approximate guides:</p>
            <p>For qualitative/interview studies: “saturation” is usually 10-25</p>
            <p>For survey: 100 (±10 error) to 1,000 (±3 error) for binary (%) outcomes; 30 for continuous outcomes (such as time to treatment)</p>
            <p>For comparative studies: 50:50 rule</p>
        </i>
        <InputTextSingleLine
			question="What is the planned sample size?"
			v-model="$tera.project.AuditWizard.plannedSampleSize"
            placeholder="100 medical records (EMR based) or 100 clinical staff members (survey)"
		/>
        <BasePreviewOutput :component="outputComponent" />
    </div>
</template>
<script>
import InputTextSingleLine from "@/components/InputTextSingleLine.vue";
import OutputAuditSampleSize from "./OutputAuditSampleSize.vue";

export default {
    name: "ViewAuditSampleSize",
    components: {
        InputTextSingleLine
    },
    data() {
		return {
			outputComponent: OutputAuditSampleSize
            }
        }
    }
</script>
<style scoped></style>